export function Filter() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Filter</title>
      <g clipPath="url(#clip0_5486_10564)">
        <path
          d="M7.60742 13.0083H10.2741"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.27539 3.67529H15.6087"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.94141 8.3418H12.9414"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5486_10564">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.941406 0.341797)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
